import React from 'react';
import { connect } from 'react-redux';
import { getSortedIds } from '../../common/helper';
import { fetchChartImage, REDUCER_NAME } from '../reducer';
import '../../top-mover.scss';
import { GridImage } from './../../../../common/grid-image';

const mapStateToProps = state => {
  return {
    listId: state[REDUCER_NAME].listDataTopNewLowTicker,
    component: state[REDUCER_NAME].component,
    sortState: state[REDUCER_NAME].sortState,
    listObjectDataTopNewLowByTicker:
      state[REDUCER_NAME].listObjectDataTopNewLowByTicker,
  };
};

const mapDispatchToProps = {
  fetchImage: fetchChartImage,
};

const getImageFromRedux = state => state[REDUCER_NAME].images;

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Chart);

function Chart(props) {
  const { listId, sortState, listObjectDataTopNewLowByTicker: data } = props;
  return (
    <GridImage
      {...props}
      listId={getSortedIds(listId, sortState, data)}
      getImageFromRedux={getImageFromRedux}
    />
  );
}
